export default __webpack_public_path__ + "505f3ed2dcf3d680201d430f26315930.svg";